// Правый клик по пустому месту строки: дата под курсором запоминается до выбора пункта, а пока меню
// открыто, экран показывает контур там, куда ляжет новая задача (hintOf решает, где именно).
import { useRef } from 'react';
import { Plus, Zap } from 'lucide-react';
import { Menu, type MenuItem } from '@core/ui/Menu';
import { useCanWrite } from '@core/auth/access';
import type { ISODate } from '@core/dates';
import { dateAtX, type Grid } from './geometry';

export function NewTaskHereMenu<H>({ grid, hintOf, onHint, onNewAt, onQuickAt, extra }: { grid: Grid; hintOf: (date: ISODate) => H; onHint: (h: H | null) => void; onNewAt: (date: ISODate) => void; onQuickAt?: (h: H) => void; extra?: (date: ISODate) => MenuItem[] }) {
  const menuDate = useRef<ISODate | null>(null);
  const canWrite = useCanWrite();
  if (!canWrite) return null;
  return (
    <Menu
      items={[
        ...(onQuickAt ? [{ label: 'Quick task here', onSelect: () => { if (menuDate.current) onQuickAt(hintOf(menuDate.current)); }, icon: Zap }] : []),
        { label: 'New task here…', onSelect: () => { if (menuDate.current) onNewAt(menuDate.current); }, icon: Plus },
        ...(extra && menuDate.current ? (() => { const more = extra(menuDate.current); return more.length ? ['sep' as const, ...more] : []; })() : []),
      ]}
      onOpenChange={(open) => onHint(open && menuDate.current ? hintOf(menuDate.current) : null)}
    >
      <div className="absolute inset-0" onContextMenu={(e) => { const r = e.currentTarget.getBoundingClientRect(); menuDate.current = dateAtX(e.clientX - r.left, grid); }} />
    </Menu>
  );
}
